// extracted by mini-css-extract-plugin
export default {"column__container":"styles_column__container__YxA9d"};